/**
 * @file index.tsx
 * @description Public entry point for the contract drawer/page header.
 * @module features/contracts/components/ContractDrawerHeader
 */

export { default } from "./ContractDrawerHeaderContainer";
export type { ContractDrawerHeaderContainerProps } from "./ContractDrawerHeaderContainer";
export type { ContractDrawerHeaderVariant } from "./ContractDrawerHeaderView";
